import useSetLoading from '@/hooks/useSetLoading';
import { AxiosResponse } from 'axios';
import { useCallback } from 'react';
import { useSetRecoilState } from 'recoil';
import { deliveryState } from '@/states/deliveryState';
import { ApiUrl, Constants } from '@/utils/constants';
import alertState from '@/states/alertState';
import { getSigV4HeadersForGet, isExpiredToken } from '@/utils/cognito';
import api from '@/utils/api';
import { DeliveryInfoResponse } from '@/types/api/mypage/deliveryInfo';
import url from '@/utils/config';

/**
 * 配送情報取得APIの呼び出しフック。
 * 端末や機器の配送状況を取得し、配送確認画面の表示に利用する。
 *
 * @returns execute - API実行関数
 */
const useGetDelivery = () => {
  const { startLoading, finishLoading } = useSetLoading();

  const setDelivery = useSetRecoilState(deliveryState);
  const setAlert = useSetRecoilState(alertState);

  const execute = useCallback(async (isGetOpticalSignalStatus: boolean) => {
    // 光信号ステータスの要否をクエリで切り替え、同一APIで取得内容を分岐する。
    const apiUrl = `${ApiUrl.Read.DELIVERY_INFO}?is_get_optical_signal_status=${isGetOpticalSignalStatus}`;
    startLoading(apiUrl);
    const headers = await getSigV4HeadersForGet(apiUrl);

    await api
      .get(apiUrl, headers)
      .then((res: AxiosResponse<DeliveryInfoResponse>) => {
        // 配送詳細画面から共通参照できるよう、レスポンスをstateへ保持する。
        setDelivery(res.data);
      })
      .catch((error: any) => {
        if (isExpiredToken(error)) {
          sessionStorage.clear();
          window.location.href = url('/login');
          return;
        }
        // 配送情報の取得失敗は共通アラートで通知する。
        setAlert({
          isOpen: true,
          apiType: Constants.ApiType.API_GET,
        });
      })
      .finally(() => finishLoading(apiUrl));
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
  return { execute };
};

export default useGetDelivery;
